import { createFileRoute } from "@tanstack/react-router";
import { TicketDetailView } from "@/components/tickets/TicketDetailView";

export const Route = createFileRoute("/tickets/$id")({
  component: TicketDetailPage,
});

/**
 * A request as a page of its own.
 *
 * ⚠️ The screen lives in `TicketDetailView` since D-153, because the ticket list draws the
 * same screen in its split-view pane. This route adds nothing to it but the address: the
 * opaque number in the URL is what addresses a request (D-4), and it goes straight through.
 */
function TicketDetailPage() {
  const { id } = Route.useParams();

  return <TicketDetailView number={id} />;
}
